import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "features/auth/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = (RootApp) =>
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <RootApp />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );

// REACT_APP_TARGET (set at build time, see package.json) picks which root app compiles
// into this bundle. The import() in the unused branch is dead-code-eliminated in the
// production build, so the public bundle ships no admin code and the admin bundle ships
// no marketing code.
if (process.env.REACT_APP_TARGET === "admin") {
  import("./AdminApp").then(({ default: AdminApp }) => renderApp(AdminApp));
  // Register the PWA / push service worker (admin site only) so it installs and can
  // receive background push. The public site stays a plain website.
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .catch((err) => console.error("Service worker registration failed:", err));
    });
  }
} else {
  import("./App").then(({ default: App }) => renderApp(App));
  // Register a minimal, cache-free service worker so the public site is
  // installable as a PWA. It does NO caching (online only); see public/sw.js.
  // Production only, so the dev server (npm start) is never controlled by a worker.
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .catch((err) => console.error("Service worker registration failed:", err));
    });
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
